import { callAgroApi } from '@services/agroapi';
export const withTransactions = () => ({
  actions: {
    createTransaction(txData: {
      source_id: string;
      destination_id: string;
      datetime: string;
      qty_exchanged: number;
      extra: {
        income: number | null;
        income_unit: string | null;
        crop_quality: number | null;
        crop_quality_unit: string | null;
      };
    }, orgId: string) {
      return callAgroApi(`/organizations/${orgId}/txes`, 'POST', txData);
    },
    updateTransaction(txData: {
      source_id: string;
      destination_id: string;
      datetime: string;
      qty_exchanged: number;
      extra: {
        income: number | null;
        income_unit: string | null;
        crop_quality: number | null;
        crop_quality_unit: string | null;
      };
    }, txId: string) {
      return callAgroApi(`/txes/${txId}`, 'PATCH', txData);
    },
    deleteTransaction(txId: string) {
      return callAgroApi(`/txes/${txId}`, 'DELETE');
    }
  }
});